// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1216":"vendors","6377":"main"}[chunkId] + "." + {"1216":"dd57fa40","6377":"a4aae74e"}[chunkId] + ".css";
};